import { render, staticRenderFns } from "./RecordingConflictsDetail.vue?vue&type=template&id=55aa45da&"
import script from "./RecordingConflictsDetail.vue?vue&type=script&lang=js&"
export * from "./RecordingConflictsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports